export const supportHeader = {
    aboutTheService: 'サービスについて',
    howToUse: '使い方',
    glossary: '用語集',
    selectLang: '日本語'
}
